import { useEffect, useState } from 'react';
import { AccessibilityInfo } from 'react-native';

/**
 * CORE-847 — «уважать prefers-reduced-motion» as one hook.
 *
 * On web react-native-web backs `isReduceMotionEnabled` with the
 * `(prefers-reduced-motion: reduce)` media query, so this reads the browser
 * setting the spec asks for without touching `window` directly (I-2); on native
 * it is the OS «Reduce Motion» switch. Same call, both platforms.
 *
 * Callers use it to skip STARTING their loops — a reduced-motion user should get
 * the static end state (ring + glow, no pulse), not an animation that runs and
 * is hidden.
 */
export function useReduceMotion(): boolean {
  const [reduceMotion, setReduceMotion] = useState(false);

  useEffect(() => {
    let mounted = true;
    AccessibilityInfo.isReduceMotionEnabled()
      .then((enabled) => { if (mounted) setReduceMotion(enabled); })
      .catch(() => undefined);
    const subscription = AccessibilityInfo.addEventListener('reduceMotionChanged', setReduceMotion);
    return () => {
      mounted = false;
      subscription.remove();
    };
  }, []);

  return reduceMotion;
}
